<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/V9LN4Y/tc-custom/9781488044939.jpg?1699984645385" alt="This image is the cover for the book His Contract Christmas Bride, Conveniently Wed!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">His Contract Christmas Bride, Conveniently Wed!
      </h1>
      <p class="bookDescription body article font2">
        <b><i>A deal before the altar</i></b><b></b><br/><br/>A desire unlocked by the Greek!<br/><br/>As new guardian to his orphaned nephew, CEO Drakon must marry. And caring Lucy is the ideal choice. His terms include a lavish Christmas wedding and nights of tantalizing pleasure. But that’s all emotionally guarded Drakon can offer!<br/><br/>Lucy cannot believe Drakon is proposing a marriage of convenience—their all-consuming island fling left her heartbroken! But Lucy’s adamant his nephew won’t grow up without a mother. And soon she realises she can’t be just a wife in name only. Dare she hope Drakon could give anything more…?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23a8552e